import { useMutation, useQueryClient } from "@tanstack/react-query";
import { submitAML } from "./services";

export const useSubmitAMLMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: submitAML,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ["overview"],
        }),
        queryClient.invalidateQueries({
          queryKey: ["customer", "metadata"],
        }),
      ]);
    },
  });
};
